<div class="page__section l-wrapper _sm">
  <div class="card">
    <div class="card__head l-wrapper">
      <div class="card__title h2" i18n="@@PageNotFoundTitle">Page not found</div>
    </div>
    <div class="card__body l-wrapper">
      <div class="block-404">
        <div class="block-404__caption h4" i18n="@@PageNotFoundCaption">The page you were looking for doesn't exist.</div>
        <div class="block-404__back">
          <button routerLink="/" mat-raised-button color="accent" i18n="@@PageNotFoundButtonText">Main page</button>
        </div>
      </div>
    </div>
  </div>
</div>
